* {
  box-sizing: border-box;
}

:host {
  display: block;
  max-width: 100%;
}

gz-link {
  padding-top: calc(var(--spacer) * 10);
}
